import { useSearchParams } from "react-router-dom";

type ProgramView = "courses" | "checklist";

export function useProgramView(): [ProgramView, (view: ProgramView) => void] {
    const [searchParams, setSearchParams] = useSearchParams();
    const view = (searchParams.get("view") ?? "courses") as ProgramView;

    const setView = (newView: ProgramView) => {
        setSearchParams(
            (prev) => {
                const next = new URLSearchParams(prev);
                if (newView === "courses") {
                    next.delete("view");
                } else {
                    next.set("view", newView);
                }
                return next;
            },
            { replace: true }
        );
    };

    return [view, setView];
}

export default function ProgramTabs() {
    const [view, setView] = useProgramView();

    const tabs: { id: ProgramView; label: string }[] = [
        { id: "courses", label: "Courses" },
        { id: "checklist", label: "Checklist" },
    ];

    return (
        <div className="flex gap-1 border-b border-gray-200 mt-4">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => setView(tab.id)}
                    className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                        view === tab.id
                            ? "border-indigo-500 text-indigo-600"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
